import { useAtomValue } from 'jotai';
import { currentKpiIdAtom } from '@src/atoms/panels';
import kpiStore from '@src/globalStore/kpiStore';

/**
 * Get current KPI config from kpiList and currentKpiId.
 * Use outside React (e.g. sagas) when you have a Jotai store reference.
 */
export function getCurrentKpiConfig(store: { get: (atom: any) => any }): any {
  const kpiId = store.get(currentKpiIdAtom);
  if (kpiId == null) return null;
  const list = kpiStore.getState().kpiList;
  const match = list?.find((k: any) => k.kpiID === kpiId);
  return match ?? (list?.length ? list[0] : null);
}

/**
 * Hook: get current KPI config from kpiList (Zustand) and currentKpiId (Jotai).
 */
export function useCurrentKpiConfig() {
  const currentKpiId = useAtomValue(currentKpiIdAtom);
  const kpiList = kpiStore((state) => state.kpiList);

  if (currentKpiId == null) return null;
  const match = kpiList?.find((k: any) => k.kpiID === currentKpiId);
  return match ?? (kpiList?.length ? kpiList[0] : null);
}
